import api from './api';

// The surgeons the practice works with — their practice numbers go on claims as
// the referring provider. Deactivate / reactivate are admin only.
const surgeonService = {
  list: (q, { inactive = false, missingNumber = false } = {}) =>
    api.get('/surgeons', {
      params: { q: q || undefined, include_inactive: inactive ? 1 : undefined, missing_number: missingNumber ? 1 : undefined },
    }).then((r) => r.data.surgeons || []),
  get: (id) => api.get(`/surgeons/${id}`).then((r) => r.data.surgeon),
  // A 409 with code 'possible_duplicate' carries `matches`; resend with confirm_duplicate: true to add anyway.
  create: (payload) => api.post('/surgeons', payload).then((r) => r.data.surgeon),
  update: (id, payload) => api.put(`/surgeons/${id}`, payload).then((r) => r.data.surgeon),
  setActive: (id, active) => api.post(`/surgeons/${id}/${active ? 'reactivate' : 'deactivate'}`).then((r) => r.data.surgeon),
};

export default surgeonService;
